// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ih-0";